import LoadingComponent from '@/pages/components/loadingComponent'
import Loadable from 'react-loadable'

export default [
  {
    component: Loadable({
      loader: () => import('@/pages/courierTask/taskCenter/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/courierTask/taskCenter',
    exact: true,
    meta: {
      title: '任务中心'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/courierTask/taskDetail/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/courierTask/taskDetail',
    meta: {
      title: '任务详情'
    }
  }
]
